
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc/pre-syllabus",
      function () {
        return require("private-next-pages/tnpsc/pre-syllabus.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc/pre-syllabus"])
      });
    }
  